export const TICKET_STATUSES = {
    OPEN: 'OPEN',
    IN_PROGRESS: 'IN_PROGRESS',
    ON_HOLD: 'ON_HOLD',
    RESOLVED: 'RESOLVED',
    CLOSED: 'CLOSED',
    REOPENED: 'REOPENED',
};
/**
 * Per-type status overrides — reserved for future use.
 * Currently all ticket types use the generic TICKET_STATUSES and VALID_TRANSITIONS above.
 * When a ticket type needs a distinct workflow, add its statuses and transitions here.
 */
export const PRIORITIES = {
    LOW: 'LOW',
    NORMAL: 'NORMAL',
    HIGH: 'HIGH',
    URGENT: 'URGENT',
};
/** Numeric priority levels (higher = more urgent) */
export const PRIORITY_LEVEL = {
    LOW: 0,
    NORMAL: 1,
    HIGH: 2,
    URGENT: 3,
};
/** Valid status transitions — escalation is a boolean flag, not a status */
export const VALID_TRANSITIONS = {
    OPEN: ['IN_PROGRESS', 'RESOLVED'],
    IN_PROGRESS: ['ON_HOLD', 'RESOLVED', 'OPEN'],
    ON_HOLD: ['IN_PROGRESS', 'RESOLVED'],
    RESOLVED: ['CLOSED', 'IN_PROGRESS', 'REOPENED'],
    CLOSED: ['REOPENED'],
    REOPENED: ['IN_PROGRESS', 'RESOLVED', 'ON_HOLD'],
};
/**
 * Who can trigger each transition.
 * External users (EXTERNAL_OPERATOR_USER) may move tickets to RESOLVED, and may
 * reopen a RESOLVED or CLOSED ticket (RESOLVED/CLOSED -> REOPENED) — e.g. when they
 * disagree that the ticket is solved. All other transitions are internal-only.
 */
export const TRANSITION_ROLES = {
    'OPEN->IN_PROGRESS': ['UNIFIBER_OPERATOR', 'SYSTEM_ADMIN'],
    'OPEN->RESOLVED': ['UNIFIBER_OPERATOR', 'SYSTEM_ADMIN', 'EXTERNAL_OPERATOR_USER'],
    'IN_PROGRESS->ON_HOLD': ['UNIFIBER_OPERATOR', 'SYSTEM_ADMIN'],
    'IN_PROGRESS->RESOLVED': ['UNIFIBER_OPERATOR', 'SYSTEM_ADMIN', 'EXTERNAL_OPERATOR_USER'],
    'IN_PROGRESS->OPEN': ['UNIFIBER_OPERATOR', 'SYSTEM_ADMIN'],
    'ON_HOLD->IN_PROGRESS': ['UNIFIBER_OPERATOR', 'SYSTEM_ADMIN'],
    'ON_HOLD->RESOLVED': ['UNIFIBER_OPERATOR', 'SYSTEM_ADMIN', 'EXTERNAL_OPERATOR_USER'],
    'RESOLVED->CLOSED': ['UNIFIBER_OPERATOR', 'SYSTEM_ADMIN'],
    'RESOLVED->IN_PROGRESS': ['UNIFIBER_OPERATOR', 'SYSTEM_ADMIN'],
    'RESOLVED->REOPENED': ['UNIFIBER_OPERATOR', 'SYSTEM_ADMIN', 'EXTERNAL_OPERATOR_USER'],
    'CLOSED->REOPENED': ['UNIFIBER_OPERATOR', 'SYSTEM_ADMIN', 'EXTERNAL_OPERATOR_USER'],
    'REOPENED->IN_PROGRESS': ['UNIFIBER_OPERATOR', 'SYSTEM_ADMIN'],
    'REOPENED->RESOLVED': ['UNIFIBER_OPERATOR', 'SYSTEM_ADMIN', 'EXTERNAL_OPERATOR_USER'],
    'REOPENED->ON_HOLD': ['UNIFIBER_OPERATOR', 'SYSTEM_ADMIN'],
};
//# sourceMappingURL=statuses.js.map